/*!
 * Aero-Gro Assistant — self-serve FAQ chat widget
 * Single self-contained file: injects its own markup, styles, and logic.
 * No external requests, no cart/script-tag Liquid dependencies.
 */
(function () {
  'use strict';

  if (window.__agChatbotLoaded) return;
  window.__agChatbotLoaded = true;

  /* ---------------------------------------------------------------------
   * Knowledge base
   * ------------------------------------------------------------------- */
  var KB = [
    // Products & how things work
    {
      q: 'How does aeroponics work?',
      a: "Aeroponics suspends plant roots in open air inside an enclosed chamber and feeds them with a fine, high-pressure mist of nutrient solution instead of soil. The roots get more oxygen than in soil or standard hydroponics, which typically means faster growth and less water used. Our “Why Aeroponics” page has the full science if you want to go deeper — or if you'd rather watch than read, check out Aero-Gro's YouTube channel for videos on aeroponics and hydroponics, or sign up for the full Aero-Gro Academy course to really dig in.",
      k: ['aeroponic', 'aeroponics', 'how does it work', 'how it works', 'mist', 'root', 'air', 'science']
    },
    {
      q: 'Where can I learn more about aeroponics and hydroponics?',
      a: "Two great ways to go deeper: watch Aero-Gro's YouTube videos, which cover aeroponics, hydroponics, water quality, and system builds in plain language — or sign up for the full Aero-Gro Academy course (10 self-paced modules, $299, or $39.99 per module) for a complete, structured education on indoor growing.",
      k: ['learn more', 'youtube', 'videos', 'video', 'watch', 'hydroponics', 'hydroponic', 'sign up', 'learn about aeroponics', 'learn about hydroponics']
    },
    {
      q: 'What’s the difference between the Hang-Ten system tiers?',
      a: "The Hang-Ten Aeroponic Grow System comes in three configurations: Base ($599) — the spray pump, pressure tank, control center, and digital timer; Expanded ($999); and Full Kit ($1,499) with the most complete setup. Every system is hand-built to order here in Allentown, PA, and you can use our System Builder to configure your exact setup.",
      k: ['hang-ten', 'hang ten', 'grow system', 'tiers', 'base', 'expanded', 'full kit', 'system price', 'system cost', 'configuration', 'aeropilot']
    },
    {
      q: 'What does the Pro 5-in-1 Water Meter measure, and what does it cost?',
      a: "The Aero-Gro Pro 5-in-1 Water Meter ($59.99) measures pH, EC (electrical conductivity), TDS (total dissolved solids), salinity, and temperature — all in one IP67 waterproof device. We recommend calibrating it every 30 days if you're actively growing, and always before a new grow cycle. A pH Recalibration Kit ($39.99) is available for that.",
      k: ['5-in-1', 'water meter', 'meter', 'ph meter', 'tds', 'ec meter', 'calibrat', 'salinity', 'test kit', 'water test']
    },
    {
      q: 'What other products and kits do you sell?',
      a: "Alongside the Hang-Ten system and the 5-in-1 Meter, we carry: the 5-Gallon GroBucket ($149, a complete single-bucket aeroponic system), the Aero-Gro Builder Kit ($199, hands-on hydroponics kit paired with the Academy), the Aeroponics Demonstrator ($399, a working desktop model), a Tent + 600W Grow Light Bundle ($499), and a 6-Port Spray Bar Manifold ($129) for expanding an existing system. Full details and current stock are on the Shop page.",
      k: ['grobucket', 'bucket', 'builder kit', 'demonstrator', 'desktop model', 'tent', 'grow light', 'spray bar', 'manifold', 'accessories', 'what do you sell', 'products']
    },
    {
      q: 'Are Aero-Gro systems customizable?',
      a: "Yes — the Hang-Ten system is modular by design. Use our online System Builder to configure your exact setup, or contact us at support@aero-gro.com for a custom configuration.",
      k: ['customiz', 'modular', 'configure', 'system builder', 'custom setup']
    },
    {
      q: 'What is Aero-Gro Academy?',
      a: "Aero-Gro Academy is our complete indoor growing masterclass — 10 self-paced modules covering water quality, lighting, plant nutrition, environmental control, hydroponics, aeroponics, plant diagnostics, and more. The full bundle is $299, or individual modules are $39.99 each. The hands-on Builder Kit ($199) pairs with it if you want to build while you learn. Prefer to sample it first? Aero-Gro's YouTube channel has free videos on aeroponics and hydroponics too.",
      k: ['academy', 'course', 'masterclass', 'module', 'learn', 'webinar', 'class']
    },
    {
      q: 'What is your warranty?',
      a: "All Aero-Gro systems include a one-year warranty covering manufacturing defects. The Pro 5-in-1 Meter is covered for 12 months from purchase. Consumables (like calibration solution) are excluded. If something arrives damaged or defective, contact us right away at support@aero-gro.com.",
      k: ['warranty', 'guarantee', 'defect', 'covered', 'broken']
    },

    // Orders & shipping
    {
      q: 'How long does shipping take?',
      a: "Accessories and smaller items ship within 1–3 business days. Hand-built systems like Hang-Ten are built to order and typically take about 3–6 weeks in production, with updates along the way. Once anything ships, delivery within the continental US usually takes 5–10 business days, and you'll get a confirmation email with tracking.",
      k: ['shipping', 'ship', 'delivery', 'how long', 'arrive', 'when will it ship', 'production time', 'lead time']
    },
    {
      q: 'How much does shipping cost?',
      a: "Shipping is calculated at checkout based on your destination and what's in your order — there's no flat rate. Alaska, Hawaii, and international orders need a custom quote, so reach out to support@aero-gro.com before ordering if that's you.",
      k: ['shipping cost', 'shipping fee', 'how much is shipping', 'international shipping', 'hawaii', 'alaska']
    },
    {
      q: 'Can I track my order?',
      a: "Yes — you'll receive a shipping confirmation email with a tracking number as soon as your order ships.",
      k: ['track', 'tracking', 'where is my order', 'order status']
    },
    {
      q: 'What is your return policy?',
      a: "We offer a 30-day return policy from the day you receive your item (EU customers also get a 14-day cooling-off period). Items need to be unused, in original packaging, with proof of purchase. Perishables, custom/personalized items, personal care products, hazardous materials, sale items, and gift cards can't be returned. To start a return, email support@aero-gro.com — don't send anything back without approval first, it'll be refused.",
      k: ['return', 'refund', 'exchange', 'send back', 'money back', 'cancel order']
    },
    {
      q: 'How long do refunds take?',
      a: "Once a return is approved, you'll be refunded to your original payment method within 10 business days (your bank may take a bit longer to post it). If it's been 15+ business days since approval and you still don't see it, contact support@aero-gro.com.",
      k: ['refund time', 'how long refund', 'when will i get my money', 'refund status']
    },
    {
      q: 'My item arrived damaged or wrong — what do I do?',
      a: "Contact us immediately at support@aero-gro.com or (610) 657-8800 with photos if you can. For shipping damage specifically, we ask for an inspection within 7 days of delivery. We'll get it sorted.",
      k: ['damaged', 'broken on arrival', 'wrong item', 'defective', 'missing parts']
    },

    // RO water install service
    {
      q: 'Tell me about the reverse osmosis (RO) install service.',
      a: "We offer three Aero-Gro American Pure RO packages, all professionally installed in the Lehigh Valley: the standard American Pure system starting at $1,149 installed, the American Pure Efficiency system (adds a non-electric permeate pump for less wastewater) starting at $1,399 installed, and the American Pure UV Defense system (adds UV treatment) starting at $1,599 installed. Every package includes procurement, professional installation, commissioning, before-and-after water testing, and a homeowner walkthrough. We'll help you figure out which fits your water and home after a free assessment. Extra costs (special parts, plumbing work, drilling) are discussed with you up front before anything is added.",
      k: ['reverse osmosis', 'ro system', 'ro install', 'ro cost', 'ro price', 'water filtration', 'drinking water', 'water system install', '1149', '1,149', 'american pure', 'how much does the ro install cost']
    },
    {
      q: 'Where do you offer the RO install service?',
      a: "We serve Allentown, Bethlehem, Easton, Emmaus, Macungie, Nazareth, Whitehall, and neighboring communities across Lehigh and Northampton Counties in the Lehigh Valley, PA.",
      k: ['service area', 'do you serve', 'lehigh valley', 'ro area', 'where do you install']
    },
    {
      q: 'How do I book the RO install?',
      a: "Fill out the request form on our RO Water System page — it just asks whether you need a new system or already have one, your countertop material, and how you'd like us to reach you (call, text, or email). We'll follow up to schedule. You can also call (610) 657-8800 or use the Contact page.",
      k: ['book', 'schedule', 'appointment', 'request ro', 'install booking']
    },

    // Store / policies / general
    {
      q: 'How can I contact Aero-Gro?',
      a: "Phone: (610) 657-8800, Mon–Fri 9am–5pm ET. Email: support@aero-gro.com (within 24 hours). Or use the Contact page — founder Andrew Woodward reads every message personally. We're based in Allentown, PA, and our support is all in-house, not outsourced.",
      k: ['contact', 'phone number', 'email', 'reach you', 'talk to a person', 'customer service', 'support hours', 'call you']
    },
    {
      q: 'Who is Aero-Gro?',
      a: "Aero-Gro is a family-owned business (Sanctuary Industries LLC) that's been around since 1996, hand-building aeroponic and hydroponic grow systems in Allentown and Bethlehem, PA. Our mission is helping people grow more with far less water.",
      k: ['who are you', 'about aero-gro', 'about you', 'company', 'history', 'family owned', 'made in usa']
    }
  ];

  var FALLBACK =
    "I don't have a good answer for that one yet in what Andrew's put together so far. For anything specific to your order or situation, email support@aero-gro.com or call (610) 657-8800, Mon–Fri 9am–5pm ET — Andrew and the team will help directly.";

  var GREETING =
    "Hey, I'm Andrew's Grower Assistant. Andrew built me from the questions he hears most often from growers, so you can get a straight answer any time, day or night. What can I help with?";

  var SUGGESTIONS = [
    'How does aeroponics work?',
    'What is your return policy?',
    'How much does the RO install cost?',
    'How can I contact you?'
  ];

  /* ---------------------------------------------------------------------
   * Matching
   * ------------------------------------------------------------------- */
  var STOPWORDS = {
    'the': 1, 'a': 1, 'an': 1, 'is': 1, 'are': 1, 'do': 1, 'does': 1, 'i': 1, 'my': 1,
    'you': 1, 'your': 1, 'to': 1, 'of': 1, 'for': 1, 'and': 1, 'in': 1, 'on': 1, 'it': 1,
    'what': 1, 'how': 1, 'can': 1, 'with': 1, 'me': 1, 'about': 1, 'have': 1, 'has': 1
  };

  function tokenize(str) {
    return (str.toLowerCase().match(/[a-z0-9]+/g) || []).filter(function (w) {
      return !STOPWORDS[w] && w.length > 1;
    });
  }

  // Cache each KB entry's haystack as a token *set* (exact-token matching),
  // so a short keyword like "ro" can't accidentally match inside an
  // unrelated word like "aeropilot" (a plain substring search would do that).
  for (var ki = 0; ki < KB.length; ki++) {
    var haystackTokens = tokenize(KB[ki].k.join(' ') + ' ' + KB[ki].q);
    var haystackSet = {};
    for (var hi = 0; hi < haystackTokens.length; hi++) haystackSet[haystackTokens[hi]] = true;
    KB[ki]._haystackSet = haystackSet;
  }

  function bestMatch(input) {
    var tokens = tokenize(input);
    if (!tokens.length) return null;

    var inputLower = input.toLowerCase();
    var best = null;
    var bestScore = 0;

    for (var i = 0; i < KB.length; i++) {
      var entry = KB[i];
      var score = 0;

      // Phrase-level boost: any keyword phrase appearing verbatim in the input.
      // (Multi-word phrases are safe with substring matching — false positives
      // only happen with very short single-word keywords, which is what the
      // token-set check below guards against.)
      for (var j = 0; j < entry.k.length; j++) {
        if (entry.k[j].length > 3 && inputLower.indexOf(entry.k[j].toLowerCase()) !== -1) {
          score += 3;
        }
      }

      // Token overlap — exact token match, not substring, so short tokens
      // like "ro" only match a real standalone "ro" token, never a
      // substring inside a longer unrelated word.
      for (var t = 0; t < tokens.length; t++) {
        if (entry._haystackSet[tokens[t]]) score += 1;
      }

      if (score > bestScore) {
        bestScore = score;
        best = entry;
      }
    }

    return bestScore >= 2 ? best : null;
  }

  /* ---------------------------------------------------------------------
   * UI
   * ------------------------------------------------------------------- */
  var css = [
    '#ag-chat-launcher{position:fixed;bottom:20px;right:20px;z-index:9998;width:60px;height:60px;border-radius:50%;',
    'background:#009444;color:#fff;border:none;cursor:pointer;box-shadow:0 4px 16px rgba(0,0,0,.22);',
    'display:flex;align-items:center;justify-content:center;transition:transform .15s ease;}',
    '#ag-chat-launcher:hover{transform:scale(1.06);}',
    '#ag-chat-launcher svg{width:26px;height:26px;}',
    '#ag-chat-launcher .ag-badge{position:absolute;top:-2px;right:-2px;width:14px;height:14px;border-radius:50%;background:#8DC63F;border:2px solid #fff;}',
    '#ag-chat-panel{position:fixed;bottom:92px;right:20px;z-index:9999;width:360px;max-width:calc(100vw - 32px);',
    'height:520px;max-height:calc(100vh - 140px);background:#fff;border-radius:16px;box-shadow:0 12px 40px rgba(0,0,0,.28);',
    'display:flex;flex-direction:column;overflow:hidden;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
    'opacity:0;transform:translateY(12px);pointer-events:none;transition:opacity .18s ease,transform .18s ease;}',
    '#ag-chat-panel.ag-open{opacity:1;transform:translateY(0);pointer-events:auto;}',
    '#ag-chat-header{background:#009444;background:linear-gradient(135deg,#009444,#00753a);color:#fff;padding:14px 16px;',
    'display:flex;align-items:center;justify-content:space-between;flex:0 0 auto;}',
    '#ag-chat-header .ag-h-title{font-weight:700;font-size:15px;letter-spacing:.01em;}',
    '#ag-chat-header .ag-h-sub{font-size:11px;opacity:.85;margin-top:2px;font-weight:400;}',
    '#ag-chat-close{background:transparent;border:none;color:#fff;cursor:pointer;padding:4px;opacity:.9;}',
    '#ag-chat-close:hover{opacity:1;}',
    '#ag-chat-body{flex:1 1 auto;overflow-y:auto;padding:14px;background:#F7F8F7;}',
    '.ag-msg{max-width:86%;margin-bottom:10px;font-size:13.5px;line-height:1.45;white-space:pre-wrap;}',
    '.ag-msg-bot{background:#fff;color:#2b2c2e;border:1px solid #e7e9e7;border-radius:12px 12px 12px 2px;padding:9px 12px;}',
    '.ag-msg-user{background:#009444;color:#fff;border-radius:12px 12px 2px 12px;padding:9px 12px;margin-left:auto;}',
    '.ag-chips{display:flex;flex-wrap:wrap;gap:6px;margin:6px 0 14px;}',
    '.ag-chip{background:#fff;border:1px solid #8DC63F;color:#00753a;border-radius:999px;padding:6px 11px;font-size:12px;',
    'cursor:pointer;font-family:inherit;text-align:left;}',
    '.ag-chip:hover{background:#8DC63F;color:#153b0d;}',
    '#ag-chat-footer{flex:0 0 auto;border-top:1px solid #e7e9e7;padding:10px;display:flex;gap:8px;background:#fff;}',
    '#ag-chat-input{flex:1;border:1px solid #d7dad7;border-radius:20px;padding:9px 14px;font-size:13.5px;',
    'font-family:inherit;outline:none;}',
    '#ag-chat-input:focus{border-color:#009444;}',
    '#ag-chat-send{background:#8DC63F;color:#153b0d;border:none;border-radius:50%;width:38px;height:38px;',
    'flex:0 0 auto;cursor:pointer;display:flex;align-items:center;justify-content:center;}',
    '#ag-chat-send:hover{background:#7bb52f;}',
    '#ag-chat-disclaimer{font-size:10.5px;color:#8a8d8a;text-align:center;padding:4px 10px 8px;background:#fff;}',
    '@media (max-width:480px){#ag-chat-panel{right:12px;left:12px;width:auto;bottom:84px;height:min(70vh,560px);}',
    '#ag-chat-launcher{right:16px;bottom:16px;}}'
  ].join('');

  function injectStyles() {
    var style = document.createElement('style');
    style.id = 'ag-chat-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function el(tag, attrs, html) {
    var node = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) node.setAttribute(k, attrs[k]);
    }
    if (html !== undefined) node.innerHTML = html;
    return node;
  }

  function build() {
    injectStyles();

    var launcher = el('button', {
      id: 'ag-chat-launcher',
      type: 'button',
      'aria-label': "Open Andrew's Grower Assistant chat"
    },'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg><span class="ag-badge"></span>');

    var panel = el('div', { id: 'ag-chat-panel', role: 'dialog', 'aria-label': "Andrew's Grower Assistant" });

    var header = el('div', { id: 'ag-chat-header' },
      '<div><div class="ag-h-title">Andrew’s Grower Assistant</div><div class="ag-h-sub">Built by Andrew Woodward · automated tool</div></div>'
    );
    var closeBtn = el('button', { id: 'ag-chat-close', type: 'button', 'aria-label': 'Close chat' },
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"></path></svg>');
    header.appendChild(closeBtn);

    var body = el('div', { id: 'ag-chat-body' });

    var footer = el('div', { id: 'ag-chat-footer' });
    var input = el('input', {
      id: 'ag-chat-input',
      type: 'text',
      placeholder: 'Ask a question…',
      autocomplete: 'off'
    });
    var sendBtn = el('button', { id: 'ag-chat-send', type: 'button', 'aria-label': 'Send' },
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m22 2-7 20-4-9-9-4Z"></path></svg>');
    footer.appendChild(input);
    footer.appendChild(sendBtn);

    var disclaimer = el('div', { id: 'ag-chat-disclaimer' },
      'An automated tool Andrew built from real grower questions — for anything else, email support@aero-gro.com or call (610) 657-8800.');

    panel.appendChild(header);
    panel.appendChild(body);
    panel.appendChild(footer);
    panel.appendChild(disclaimer);

    document.body.appendChild(launcher);
    document.body.appendChild(panel);

    var opened = false;

    function addMessage(text, from) {
      var msg = el('div', { class: 'ag-msg ' + (from === 'user' ? 'ag-msg-user' : 'ag-msg-bot') }, '');
      msg.textContent = text;
      body.appendChild(msg);
      body.scrollTop = body.scrollHeight;
    }

    function addChips(list) {
      var wrap = el('div', { class: 'ag-chips' });
      list.forEach(function (q) {
        var chip = el('button', { type: 'button', class: 'ag-chip' }, '');
        chip.textContent = q;
        chip.addEventListener('click', function () {
          handleUserInput(q);
        });
        wrap.appendChild(chip);
      });
      body.appendChild(wrap);
      body.scrollTop = body.scrollHeight;
    }

    function handleUserInput(text) {
      text = (text || '').trim();
      if (!text) return;
      addMessage(text, 'user');
      input.value = '';
      var match = bestMatch(text);
      window.setTimeout(function () {
        if (match) {
          addMessage(match.a, 'bot');
        } else {
          addMessage(FALLBACK, 'bot');
        }
      }, 260);
    }

    function openPanel() {
      panel.classList.add('ag-open');
      opened = true;
      if (!body.childNodes.length) {
        addMessage(GREETING, 'bot');
        addChips(SUGGESTIONS);
      }
      window.setTimeout(function () { input.focus(); }, 200);
    }

    function closePanel() {
      panel.classList.remove('ag-open');
    }

    launcher.addEventListener('click', function () {
      if (opened && panel.classList.contains('ag-open')) {
        closePanel();
      } else {
        openPanel();
      }
    });
    closeBtn.addEventListener('click', closePanel);
    sendBtn.addEventListener('click', function () { handleUserInput(input.value); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') handleUserInput(input.value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
